export interface IApiResponse {
    data: any,
    message: string,
    status_code: number,
    status: number
}


// All user response
export interface allUsers {
    createdAt: string,
    email: string,
    name: string,
    display_name?: string,
    status: boolean,
    updatedAt: string,
    wallet_address: string,
    _id: string
}

/**
 * Transh logs
 */
export interface transhLogs {
    block: number,
    created_at: string,
    gas_fee: number,
    message: string,
    method: string,
    nft_name: string,
    nft_ids: any[],
    receiver: { wallet_address?: string; [key: string]: any } | null,
    _id: string,
    transaction_hash: string,
    sender: { wallet_address?: string; [key: string]: any } | null,
    type: number,
    data: string,
    request_ip:string,
    last_login_browser:string,
    last_login_os:string,
    loan_amount:number,
    currency_symbol:string,
    display_symbol?: string
}

/**
 * KYC logs
 */
export interface kycLogs {
    created_at: string,
    scan_reference: string,
    verification_status: number,
    failure_reason?: string
}

/**
 * Currency
 */
export interface currency {
    address: string,
    chain_id: number,
    createdAt: string,
    name: string,
    network_name: string,
    order: number,
    status: boolean,
    symbol: string,
    display_symbol?: string,
    updatedAt: string,
    _id: string,
    balance?: number,
}
// Pagination
export interface IPagination {
    hasNextPage: boolean,
    hasPrevPage: boolean,
    limit: number,
    nextPage: number,
    page: number,
    pagingCounter: number,
    prevPage: number,
    totalDocs: number,
    totalPages: number
}

/**
 * Wallet account
 */
export interface walletAccount {
    state: {
        data: {
            account: string,
            chain: {
                id: number
            }
        },
        chains: [
            {
                nativeCurrency: {
                    name: string,
                }
            }
        ]
    }
}

export interface AccountState {
    account: string,
    chainId: number,
    isConnected: boolean,
}

/**
 * user details
 */
export interface IuserDetails {
    apple_signin: boolean,
    createdAt: string,
    email: string,
    fire_block_address: string,
    google_signIn: boolean,
    is_blocked: boolean,
    kyc_enable: boolean,
    kyc_verified: number,
    
    last_online: string,
    name: string,
    first_name: string,
    last_name: string,
    notes: string,
    updatedAt: string,
    wallet_address: string,
    _id: string,
    nft_count?:any,
    onboard_asset_count?:any,
    active_loans?:any,
    phone_number?:number,
    display_name?:string,
    past_loans?:number,
    legal_last_name?:string,
    legal_first_name?:string,
    withdrawal_wallet_address?:string,
    /** Address the user asked to switch to, waiting for review in Requested wallets. */
    requested_withdrawal_wallet_address?: string,
    /** WITHDRAW_WALLET_STATUS on the backend: 0 pending, 1 approved, 2 rejected. */
    requested_withdrawal_wallet_address_status?: number,
    email_verified?: boolean,
    profile_image?: string,
    signature?: string,
    last_login_browser?: string,
    last_login_os?: string,
    community_id?: ICommunity | null,
    community_joined_at?: string | null
}

/**
 * A community a user belongs to (populated on get-user) or can be put in
 */
export interface ICommunity {
    community_id: number,
    name: string,
    logo_url?: string,
    status?: 'active' | 'disabled'
}

export const LoanRequestStatus = {
    NOT_ACCEPTED: 0,
    ACCEPTED: 1,
    REPAID: 2,
    FORECLOSED: 3,
    CANCELLED: 4,
    DEFAULT: 5
};

/**
 * Delivery response
 */
export interface deliveryResponse {
    chain_id: number,
    city: string,
    country: string,
    createdAt: string,
    house_number: number,
    is_deleted: boolean,
    nft_id: {
        "attributes": [],
        "delivery_type": string,
    },
    order_id: string,
    postal_code: number,
    status: number,
    street: string,
    updatedAt: string,
    user_id: object,
    _id: string,
    previous_status: Object
    quantity: number,
    country_code: string,
    phone_number: string,
    instructions: string,
    pickup_time: string,
    notes: string,
    email: string
}

export const POLTERSORRY ='GAS TREASURY'
export const WITHDRAWAL  ="Withdrawal"
// An on-chain transaction hash. Withdrawal logs hold the Fireblocks transaction id until the confirmation webhook swaps in the chain hash.
export const TX_HASH_PATTERN = /^0x[0-9a-fA-F]{64}$/


/**
 * Delivery status
 */
export interface deliveryStatus {
    _id: string,
    name: string,
    status: number,
    createdAt: string,
    updatedAt: string

}

// Contains both user log and transaction log enums
export enum MethodTypes {
    REQ_LOAN = 'Request loan',
    UPDATE_LOAN = 'Updated loan request',
    ACCEPT_LOAN = 'Accepted loan',
    COUNTER_OFFER = 'Counter offer',
    RECOUNT_OFFER = 'Recounter offered',
    BORROW_RECOUNT_OFFER = 'Borrower recounter offered',
    CANCEL_LOAN = 'Cancel loan',
    CREATE_SELL_ORDER = 'Created sell order',
    CANCEL_SELL_ORDER = 'Cancelled sell order',
    PURCHASE_SELL_ORDER = 'Purchased sell order',
    PURCHASE_PARTNER_ITEM = 'Purchased partner item',
    LOAN_REPAID = 'Loan repaid',
    FORECLOSE_LOAN = 'Foreclosed loan',
    SIGNUP = 'Signup',
    USER_BLOCK = 'User blocked',
    USER_UNBLOCK = 'User unblocked',
    UPDATE_USER = 'Updated user',
    DELETE_USER = 'Deleted user',
    ITEM_TRANSFER = 'Item transferred',
    CREATE_ITEMBID = 'Created item bid',
    EDIT_ITEMBID = 'Edited item bid',
    CANCEL_ITEMBID = 'Cancelled item bid',
    ACCEPT_ITEMBID = 'Accepted item bid',
    ITEM_MINTED = 'Item minted',
    PARTNER_COL_CREATED = 'Partner collection created',
    PARTNER_ITEM_CREATED = 'Partner item created',
    BURN_ITEM = 'Burned item',
    EMAIL_VERIFY = 'Email verified',
    GOOGLE_AUTH = 'Google auth',
    APPLY_AUTH = 'Apple auth',
    LOAN_DEFAULT = 'Loan defaulted',
    CREATE_ITEM_LOAN_BID = 'Create loan bid',
    EDIT_ITEM_LOAN_BID = 'Edited item loan bid',
    ACCEPT_ITEM_LOAN_BID = 'Accepted item loan bid',
    CANCEL_ITEM_LOAN_BID = 'Cancelled item loan bid',
    BULK_MINT = 'Bulk minted',
    COUNTER_OFFER_OPEN_LOAN_BID ="Counter offered open loan bid",
    CREATE_BULK_LOAN_BID="Created bulk loan bid",
    ACCEPT_BULK_LOAN_BID="Accepted bulk loan bid",
    CANCEL_BULK_LOAN_BID="Cancelled bulk loan bid",
    EDIT_BULK_LOAN_BID="Edited bulk loan bid",
    SELL_ORDER_CREATED ="Sell order created",
    REPAID_INSTALLMENT="Repaid installment",
    REQUESTEDREFINANCELOAN ='Requested Refinance Loan',
    ACCEPTEDREFINANCELOAN='Accepted Refinance Loan',
    UPDATEDREFINANCELOANREQUEST='Updated Refinance Loan Request',
    CANCELLEDREFINANCELOANREQUEST='Cancelled Refinance Loan Request',
    REQUESTEDLOANSALE ='Loan sale request',
    ACCEPTEDLOANSALEREQUEST ='Accepted Loan Sale Request',
    BUYERCOUNTEROFFERED ='Buyer Counter Offered',
    UPDATEDLOANSALEREQUEST ='Updated Loan Sale Request',
    CANCELLEDLOANSALEREQUEST ='Cancelled Loan Sale Request',
    BUNDLE_PURCHASED = 'Bundle purchased sell order'
}

export interface cPagination {
    has_next_page: boolean,
    has_prev_page: boolean,
    limit: number,
    next_page: number,
    page: number,
    pagingCounter: number,
    prev_page: number,
    total_items: number,
    total_pages: number
}

/**
 * Deposit lifecycle of an onboarded asset. Mirrors the backend `deposit_status` enum in
 * `src/constants/onboard-asset-status.js`. Null while the submission is still a draft.
 */
export type OnboardDepositStatus =
  | 'submitted'
  | 'approved'
  | 'shipped'
  | 'received'
  | 'minted';

/** Tab filters accepted by `GET /management/onboard-assets`. */
export type OnboardTab = 'draft' | 'in_progress' | 'completed';

/**
 * When each deposit milestone was reached, one slot per status — everything the deposit
 * timeline is drawn from.
 *
 * The populated slots are exactly the milestones the deposit currently holds: reaching a status
 * fills its slot, reverting one empties it, and neither disturbs any other. Deposits written
 * before the backend stored this are filled in by the API on the way out, so every record
 * arrives here dated.
 */
export type OnboardStatusTimestamps = Partial<Record<OnboardDepositStatus, string | null>>;

export interface OnboardCollectionRef {
  _id: string;
  name: string;
  collection_address: string;
  collection_owner_address?: string;
  attributes?: unknown[];
}

export interface OnboardAssetImageUrls {
  front_view?: string;
  serial_number?: string;
  photo_of_seal?: string;
  packing_view?: string;
  certificate?: string;
  invoice?: string;
}

export interface OnboardSubmission {
  _id: string;
  title: string;
  /** Value the depositor declared on the form. */
  appraisal_value?: number | null;
  /** Set once the onboarding fee is paid on chain. */
  onboarding_fee_payment?: { transaction_hash?: string | null; recorded_at?: string | null } | null;
  brand: string;
  model: string;
  custody_destination: string;
  description: string;
  category: string;
  /** The collection the depositor picked on the form. Optional there, so usually null. */
  collections: OnboardCollectionRef | null;
  /**
   * The NFT this deposit was minted as, populated with its own collection — which is the
   * collection the asset is really in, whatever was (or was not) chosen on the form.
   */
  minted_nft_id?: { _id: string; collections?: OnboardCollectionRef | null } | null;
  asset_image: string;
  asset_image_url: OnboardAssetImageUrls;
  provenance_documents: string;
  media: string;
  media_url: string[];
  provenance_url: string[];
  /**
   * How the depositor asked to be reached, collected on the deposit form's details screen.
   * Null on deposits made before the form asked for it.
   */
  phone_number: string | null;
  /** Dial code the number was entered with, e.g. `+91`. Shown in front of the number. */
  country_code: string | null;
  /** `anytime` | `morning` | `afternoon` | `evening`. */
  contact_window: string | null;
  /** false = draft (form unfinished), true = form submitted. */
  is_submitted: boolean;
  deposit_status: OnboardDepositStatus | null;
  deposit_status_timestamps?: OnboardStatusTimestamps;
  /** Owner account, populated by the API — the wallet is read from here, not stored on the deposit. */
  user_id: { _id: string; wallet_address?: string; name?: string; email?: string } | null;
  shipping_tracking_id: string | null;
  createdAt: string;
  updatedAt: string;
}
  

/** One Digital Assets Type's live price, from GET management/get-digital-asset-values. */
export interface DigitalAssetPriceQuote {
    usd_price: number | null;
    as_of: string | null;
    stale: boolean;
    /** Only present when `?quantity=` was sent: quantity × price, computed by the backend; null while stale. */
    appraisal_value?: number | null;
}

/** Response of GET management/get-digital-asset-values — quotes keyed by lowercase Type (e.g. "bitcoin"). */
export interface DigitalAssetValuesResponse {
    data: { [type: string]: DigitalAssetPriceQuote };
    message: string;
    status_code: number;
    status: boolean;
}

